module.exports = __webpack_public_path__ + "static/media/engagementRing.d9565688.webp";